import {
  STASH_QUESTION_REQUEST,
  UNSTASH_QUESTION_REQUEST,
  EMPTY_QUESTION_STASH,
  ADD_QUESTIONS_TO_TEST_SUCCESS,
  UNSUBMIT_QUESTION_FROM_TEST_SUCCESS,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function questions(state = [], action) {
  switch (action.type) {
    case STASH_QUESTION_REQUEST:
      const setter = questionsOfTheTopic => {
        if (Array.isArray(questionsOfTheTopic)) {
          return [...questionsOfTheTopic, action.questionId]
        } else {
          return [action.questionId]
        }
      }

      return dotProp(state)
        .set(`questionsByTopic.${action.topicId}`, setter)
        .value()

    case UNSTASH_QUESTION_REQUEST:
      return dotProp(state)
        .set(`questionsByTopic.${action.topicId}`, questionsOfTheTopic =>
          questionsOfTheTopic.filter(questionId => questionId !== action.questionId)
        )
        .value()

    case ADD_QUESTIONS_TO_TEST_SUCCESS:
      return dotProp(state)
        .set(`successfullySubmittedQuestions`, successfullySubmittedQuestions => [
          ...successfullySubmittedQuestions,
          ...action.questions,
        ])
        .value()

    case UNSUBMIT_QUESTION_FROM_TEST_SUCCESS:
      return (
        dotProp(state)
          // first remove it from submitted list and then remove it from selected list
          .set(`successfullySubmittedQuestions`, successfullySubmittedQuestions =>
            successfullySubmittedQuestions.filter(
              submittedQuestionId => submittedQuestionId !== action.questionId
            )
          )
          .set(`questionsByTopic.${action.topicId}`, questionsOfTheTopic =>
            questionsOfTheTopic.filter(
              selectedQuestionId => selectedQuestionId !== action.questionId
            )
          )
          .value()
      )

    case EMPTY_QUESTION_STASH:
      return dotProp(state)
        .set('questions', {})
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/questionStash.js